export enum BlockchainEcosystem {
  Evm = "evm",
  Cosmos = "cosmos",
  Solana = "solana",
}
